import {CompositionPhotoCrop} from '@dms/api/shared';

// The smallest crop side, as a share of the photo side; the BE only requires a positive size.
const MIN_CROP_SIZE = 0.01;

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

/**
 * Keeps a normalised crop inside the photo with a positive size, as the BE requires: the size is
 * limited first, then the position is moved so the crop ends at the photo edge at the latest.
 */
export const clampCrop = (crop: CompositionPhotoCrop): CompositionPhotoCrop => {
  const width = clamp(crop.width, MIN_CROP_SIZE, 1);
  const height = clamp(crop.height, MIN_CROP_SIZE, 1);

  return {
    x: clamp(crop.x, 0, 1 - width),
    y: clamp(crop.y, 0, 1 - height),
    width,
    height,
  };
};
